import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Picker } from 'react-native';

class BlockSelect extends Component {
  handlerChange = (value) => {
    const { block, onChange } = this.props;

    onChange && onChange({
      block,
      value
    });
  }

  render() {
    const { block, value } = this.props;

    return (
      <>
        <Picker
          selectedValue={block.value.length < 1 ? 0 :  value}
          // selectedValue={value}
          style={{ height: 50, width: 100 }}
          onValueChange={value => this.handlerChange(value)}
        >
          {block.elements.map((element, i) => <Picker.Item key={i} label={element.label} value={element.value} />)}
        </Picker>
      </>
    );
  }
}

BlockSelect.propTypes = {
  block: PropTypes.object,
  onChange: PropTypes.func,
  value: PropTypes.array
};

export default BlockSelect;
